/* Progressive enhancement: native scrolling, no hidden content without JS. */
(() => {
  if (window.RWCMotion) { window.RWCMotion.refresh(); return; }
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  let observer, frame = 0;
  const pending = new Set();
  function reveal(el) {
    el.classList.remove('rwc-awaiting');
    el.classList.add('rwc-visible');
    observer?.unobserve(el);
    pending.delete(el);
  }
  function refresh() {
    if (reduced.matches || !('IntersectionObserver' in window)) return;
    observer ||= new IntersectionObserver(entries => entries.forEach(e => {
      if (e.isIntersecting) reveal(e.target);
    }), { threshold: 0.06, rootMargin: '0px 0px -24px 0px' });
    document.querySelectorAll('.rwc').forEach(root => {
      root.classList.add('rwc-motion');
      root.querySelectorAll('.section-heading,.feature,.edition,.comparison,.faq>div,.closing h2,.product-art,.gallery-thumbs,.product-info>details').forEach(el => {
        const box = el.getBoundingClientRect();
        if (!box.height || el.dataset.rwcMotion) return;
        el.dataset.rwcMotion = 'true';
        el.classList.add('rwc-reveal');
        if (el.matches('.feature,.edition')) {
          el.style.setProperty('--rwc-delay', `${[...el.parentElement.children].indexOf(el) * 85}ms`);
        }
        if (box.top >= innerHeight - 25) {
          el.classList.add('rwc-awaiting');
          pending.add(el);
          observer.observe(el);
        } else el.classList.add('rwc-visible');
      });
    });
    schedule();
  }
  function update() {
    frame = 0;
    if (reduced.matches) return;
    document.querySelectorAll('.rwc .hero-art').forEach(el => {
      const box = el.getBoundingClientRect();
      if (!box.height || box.bottom < 0 || box.top > innerHeight) return;
      const travel = Math.max(-28, Math.min(28, (innerHeight * .45 - (box.top + box.height / 2)) * .075));
      el.style.setProperty('--rwc-drift', `${travel.toFixed(2)}px`);
    });
    document.querySelectorAll('.rwc .sample-frame').forEach(el => {
      const box = el.getBoundingClientRect();
      if (!box.height || box.bottom < 0 || box.top > innerHeight) return;
      const amount = Math.max(0, Math.min(1, (innerHeight - box.top) / (innerHeight + box.height)));
      el.style.setProperty('--rwc-page-scale', (1 + amount * .045).toFixed(3));
    });
  }
  function schedule() { if (!frame && !reduced.matches) frame = requestAnimationFrame(update); }
  function reset() {
    observer?.disconnect(); observer = null;
    pending.forEach(reveal); pending.clear();
    document.querySelectorAll('.rwc-motion').forEach(el => el.classList.remove('rwc-motion'));
    if (!reduced.matches) refresh();
  }
  addEventListener('scroll', schedule, { passive: true });
  addEventListener('resize', () => { refresh(); schedule(); }, { passive: true });
  addEventListener('hashchange', () => requestAnimationFrame(refresh));
  document.addEventListener('shopify:section:load', refresh);
  document.addEventListener('shopify:section:unload', () => {
    pending.forEach(el => { if (!el.isConnected) { observer?.unobserve(el); pending.delete(el); } });
  });
  document.addEventListener('focusin', e => {
    const hidden = e.target.closest?.('.rwc-awaiting');
    if (hidden) reveal(hidden);
  });
  reduced.addEventListener('change', reset);
  window.RWCMotion = { refresh };
  refresh();
})();
